import SentryErrorBoundary from './SentryErrorBoundary';
export default SentryErrorBoundary;
